import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="font-label text-sm text-primary-600 font-medium">常见问题</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              你可能想知道的几件事
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">
              关于链接失效、缓存、陌生链接与更新频率，下面逐条说明。点击问题即可展开查看答案。
            </p>
          </div>

          <div className="lg:col-span-8 space-y-2.5">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3">
                      <span className="font-heading font-black text-sm text-accent-600">
                        Q{String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                    </span>
                    <i
                      className={`flex-shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-6 pb-4 md:pb-5 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed pl-0 md:pl-10">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}